import classNames from 'classnames/bind';
import PropTypes from 'prop-types';
import React from 'react';

import style from './Totals.module.scss';

const cx = classNames.bind(style);
const labelClass = 'totals__row--label';

const Totals = ({
  subtotal,
  promotions,
  giftcard,
  delivery,
  remaining,
  serviceLevel,
  isIncludingDelivery,
}) => {
  const hasDetails = (promotions || delivery) && subtotal;
  const hasDeliveryInfos = isIncludingDelivery && delivery;

  const showPromotions = (promos) =>
    promos.map((promo) => (
      <p
        className={cx('totals__row', { promotions: 'promotion' })}
        key={promo.name}
        data-qa="promotion-details"
      >
        <span className={cx(labelClass)} data-notranslate>
          {promo.name}
        </span>
        <span>{promo.value.formattedValue}</span>
      </p>
    ));

  return (
    <div className={cx('totals')}>
      {hasDetails && (
        <p
          className={cx('totals__row', { subtotal: 'sub-total' })}
          data-qa="subtotal"
        >
          <span className={cx(labelClass)}>Subtotal</span>
          <span>{subtotal}</span>
        </p>
      )}
      {promotions && showPromotions(promotions)}
      {hasDeliveryInfos && (
        <p
          className={cx('totals__row', { delivery: 'delivery' })}
          data-qa="delivery-cost"
        >
          <span className={cx(labelClass)}>{serviceLevel}</span>
          <span>{delivery.price.formattedValue}</span>
        </p>
      )}
      {giftcard && (
        <p
          className={cx('totals__row', { giftcard: 'gift-card-total' })}
          data-qa="giftcard-total"
        >
          <span className={cx(labelClass)}>Gift card</span>
          <span>{giftcard}</span>
        </p>
      )}
      <p
        className={cx('totals__row', { total: 'grand-total' })}
        data-qa="grand-total"
      >
        <span data-qa="grand-total-copy" className={cx(labelClass)}>
          Total{isIncludingDelivery && <span> to pay</span>}
        </span>
        <span>{remaining}</span>
      </p>
    </div>
  );
};

Totals.propTypes = {
  subtotal: PropTypes.string,
  promotions: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string,
      value: PropTypes.shape({
        formattedValue: PropTypes.string,
      }),
    }),
  ),
  giftcard: PropTypes.string,
  delivery: PropTypes.shape({
    serviceLevel: PropTypes.string,
    price: PropTypes.shape({
      formattedValue: PropTypes.string,
    }),
  }),
  remaining: PropTypes.string.isRequired,
  serviceLevel: PropTypes.string,
  isIncludingDelivery: PropTypes.bool.isRequired,
};

Totals.defaultProps = {
  subtotal: '',
  promotions: [],
  giftcard: '',
  delivery: {},
  serviceLevel: '',
};

export default Totals;
